module.exports = __webpack_public_path__ + "static/assets/7da192543f5921c1d541937198c0afa9.gif";